import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

import EmailInput from "src/Components/Authentication/EmailInput";
import PasswordInput from "src/Components/Authentication/PasswordInput";
import ConfirmPasswordInput from "src/Components/Authentication/ConfirmPasswordInput";
import BlueButton from "src/Components/Authentication/BlueButton";
import GoogleButton from "src/Components/Authentication/GoogleButton";
import TextInput from "src/Components/Authentication/TextInput";
import AuthService from "src/Services/API/auth.service";
import { API_URL, validatePassword } from "src/Common/function";
import { validateEmail } from "src/Common/function";
import { handleError } from "../../../Common/function";

function Signup() {
  const navigate = useNavigate();

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [company, setCompany] = useState("");
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {}, []);

  const nameChanged = (name) => {
    setName(name);
  };

  const emailChanged = (email) => {
    setEmail(email);
  };

  const passwordChanged = (p) => {
    console.log(p);
    setPassword(p);
  };

  const confirmPasswordChanged = (p) => {
    setConfirmPassword(p);
  };

  const companyChanged = (p) => {
    setCompany(p);
  };

  useEffect(() => {}, []);
  const signinButtonClicked = () => {
    navigate("/");
  };

  const blueButtonClicked = () => {
    if (handleValidation()) {
      setIsLoading(true);
      console.log("API_URL: ", API_URL);

      AuthService.register(name, email, password, company)
        .then(function (response) {
          if (response.status == 201) {
            toast("Verification Email Sent");
            navigate("/");
          }
          setIsLoading(false);
        })
        .catch(function (error) {
          handleError(error);
          setIsLoading(false);
        });
    } else {
      toast(errors);
    }
  };

  const handleValidation = () => {
    let errors = {};
    let formIsValid = true;

    if (name == "") {
      errors["name"] = "Name cannot be empty";
      formIsValid = false;
    }
    if (!validateEmail(email)) {
      errors["email"] = "Email address is invalid";
      formIsValid = false;
    }
    if (password == "") {
      errors["password"] = "Password cannot be empty";
      formIsValid = false;
    }

    if (password.length < 6) {
      errors["password"] = "Password must be at least 6 letters";
      formIsValid = false;
    }

    if (password != confirmPassword) {
      errors["confirmPassword"] = "Passwords doesn't match";
      formIsValid = false;
    }

    if (name == "") {
      errors["company"] = "Company cannot be empty";
      formIsValid = false;
    }

    setErrors(errors);
    console.log(errors);
    return formIsValid;
  };

  return (
    <div className="w-screen h-screen flex items-center justify-center">
      <div className="w-[332px] h-[411px] flex items-center justify-center">
        <div className="w-[296px] h-[400px]">
          <p className="font-OpenSansRegular text-[16px] text-titleColor text-center font-[700]">Create Account</p>

          <div className="mt-[20px]" />
          <TextInput onTextChanged={nameChanged} />
          <EmailInput onEmailChanged={emailChanged} />
          <PasswordInput onPasswordChanged={passwordChanged} isForgotButton={false} />
          <ConfirmPasswordInput onConfirmpasswordChanged={confirmPasswordChanged} />
          <TextInput onTextChanged={companyChanged} label="company" />
          <div className="mt-[5px]" />
          <BlueButton onButtonClicked={blueButtonClicked} title={"CREATE ACCOUNT"} isLoading={isLoading} />
          <div className="mt-[5px]" />
          <p
            onClick={signinButtonClicked}
            className="font-OpenSansRegular text-[10px] text-blueColor font-[400] text-center cursor-pointer"
          >
            or Login
          </p>

          <div className="w-full h-[1px] my-[20px] bg-gray-200" />

          <GoogleButton title="SIGN UP WITH GOOGLE" />

          <p className="font-OpenSansRegular text-[10px] text-subTitleColor text-center font-[400] mt-[10px]">
            By logging into the Makani Platform, you agree with our{" "}
            <span className="cursor-pointer" onClick={() => navigate("/privacy")}>
              Privacy Policy
            </span>{" "}
            and{" "}
            <span className="cursor-pointer" onClick={() => navigate("/terms")}>
              Terms of Use
            </span>
          </p>
        </div>
      </div>
    </div>
  );
}

export default Signup;
